module.exports = __webpack_public_path__ + "static/media/The_Climb.c6ae6fee.jpg";